<template>
  <div>
    <v-dialog persistent max-width="400" v-model="popupShow">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  outline
                  hide-details
                  single-line
                  v-model="newOption"
                >
                  <template v-slot:append>
                    <v-icon @click="addOptionClick">fa-plus</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  outline
                  hide-details
                  single-line
                  :placeholder="$t('fields.search')"
                  v-model="search"
                />
              </v-flex>
              <v-flex xs12>
                <div v-for="(option, key) in searchOptions" :key="key">
                  <v-icon
                    @click="optionClick(option)"
                    v-if="!optionChecked(option)"
                    small
                    >fa-square</v-icon
                  >
                  <v-icon
                    @click="optionClick(option)"
                    v-if="optionChecked(option)"
                    small
                    >fa-check-square</v-icon
                  >
                  <span class="cursor-pointer" @click="optionClick(option)"
                    >&nbsp;&nbsp;{{ option }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="popupOk" color="success">{{ $t('buttons.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-text-field outline :label="label" :readonly="true" v-model="prettyValue">
      <template v-slot:append>
        <v-icon v-if="!readonly" @click="openPopup">fa-search</v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'TagsPopup',
  props: ['readonly', 'value', 'ajax', 'data', 'label'],
  data() {
    return {
      search: '',
      endpoint: '',
      selectedValue: [],
      options: [],
      ajaxLoaded: false,
      prettyValue: '',
      popupShow: false,
      newOption: '',
    }
  },
  computed: {
    searchOptions: function () {
      return this.options.filter(option => {
        return option.includes(this.search)
      })
    },
  },
  watch: {
    value: function () {
      this.selectedValue = this.$props.value
    },
    selectedValue: function () {
      let pretty = ''
      if (this.selectedValue != null) {
        pretty = this.selectedValue.join(', ')
      }
      this.prettyValue = pretty
      this.$emit('input', this.selectedValue)
    },
  },
  methods: {
    addOptionClick() {
      if (this.newOption != '') {
        if (this.options.indexOf(this.newOption) == -1) {
          if (this.selectedValue == null) {
            this.selectedValue = []
          }
          this.options.push(this.newOption)
          this.selectedValue.push(this.newOption)
          this.newOption = ''
        }
      }
    },
    optionClick(option) {
      if (!this.$props.readonly) {
        if (this.optionChecked(option)) {
          let index = this.selectedValue.indexOf(option)
          if (index !== -1) this.selectedValue.splice(index, 1)
        } else {
          this.selectedValue.push(option)
        }
      }
    },
    optionChecked(option) {
      return this.selectedValue.indexOf(option) != -1
    },
    openPopup() {
      this.popupShow = true
    },
    popupOk() {
      this.popupShow = false
      this.newOption = ''
    },
  },
  mounted() {
    if (this.$props.ajax) {
      this.$APICall(
        'get',
        'TAGS',
        '/' + this.$props.data,
        [],
        data => {
          this.options = data
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    }
    this.selectedValue = this.$props.value
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
